import React, { useEffect, useState } from "react";
import Table from "../../../components/table/Table";
import { useApiClient } from "../../../shared/customHooks";
import { assessmentsListTable, assessmentsTableOptions } from "../../../shared/tableObjects/admin/assessmentsListTable";
import { PageHeader } from "../../../components/header/PageHeader";
import CreateApplicationButtonsManager from "../../../components/CreateApplicationButtonsManager";

export default function AssessmentList() {
  const apiClient = useApiClient("BaseApplication");
  const headerText = [
    {
      class: "p-0 m-0 flex align-center",
      value: "List of Assessments",
      icon: "list-icon",
    },
  ];

  const { fetchData } = useApiClient("UserManagement", { identity: true });
  const [assessors, setAssessors] = useState<any>({ options: [] });

  useEffect(() => {
    fetchData("GetActiveUsersByRoles/2,3").then((res) => {
      const options = (res.data as any[]).map((user) => user.displayName).sort();
      setAssessors(options);
    });
  }, []);

  return (
    <>
      <PageHeader headerText={headerText} hideBreadcrumbs={true} icon={"icon"}></PageHeader>
      <div className="list-table">
        <CreateApplicationButtonsManager />{" "}
        <Table apiClient={apiClient} label={""} columns={assessmentsListTable("assessments", assessors)} tableOptions={assessmentsTableOptions} />
        <p className="fieldadv mb-5">
          Note: the em dash (—) in the "KPI" column indicates a null value, which indicates the action required is not with the Assessment team
        </p>
      </div>
    </>
  );
}
